import { IActionButtonV21 } from '../../repositories/chats/entities/action_button_v2/ActionButtonV21';
import { IActionButtonV31 } from '../../repositories/chats/entities/action_button_v3/ActionButtonV31';

type TActionButtonSchema = IActionButtonV21 | IActionButtonV31;

// матчит строку вида cianurl://cian.ru/daily_rent/write_review/289006885/?tripStatus=success
const URL_REGEX = /(cianurl:\/\/cian.ru\/daily_rent\/write_review\/)(\d+)(\/\?tripStatus=success)/gi;

// матчит строку вида https://www.cian.ru/booking-calendar/{offer_id}/
const BOOKING_CALENDAR_SETTINGS_URL_REGEX = /booking-calendar\/(\d+)/i;

export const doesButtonHaveDailyrentReviewLink = ({ link }: TActionButtonSchema) => {
  return link && link.match(URL_REGEX)?.length;
};

export const doesButtonHaveBookingCalendarSettingsLink = ({ link }: TActionButtonSchema) => {
  return link && link.match(BOOKING_CALENDAR_SETTINGS_URL_REGEX);
};

export const shouldShowDailyrentButtons = (actionButtons: TActionButtonSchema[] | null | undefined): boolean => {
  if (!actionButtons) {
    return false;
  }

  return actionButtons.some(doesButtonHaveDailyrentReviewLink);
};
